import './App.css';

function App() {
  return (
    <div className="privacy-container">
      <div className="privacy-content">
        <header className="privacy-header">
          <h1>Política de Privacidade</h1>          
        </header>

        <section>
          <h2>1. Sobre este app</h2>
          <p>
            Este aplicativo é um projeto de estudos e está em constante evolução. Fornece um controle de ponto simples e
            voltado para testes e aprendizagem. Não se trata de uma solução comercial completa.
          </p>
        </section>

        <section>
          <h2>2. Dados que coletamos</h2>
          <ul>
            <li>Registros de entrada/saída (data e hora) para controle de jornada.</li>
            <li>Dados técnicos do dispositivo (modelo, sistema operacional) apenas para fins de diagnóstico.</li>
          </ul>
          <p className="note">* Durante testes, dados podem ser armazenados localmente no dispositivo.</p>
        </section>

        <section>
          <h2>3. Como usamos os dados</h2>
          <p>
            As informações coletadas servem apenas para o funcionamento básico do app, exibição do histórico de ponto e
            para diagnóstico de problemas durante o desenvolvimento. Não vendemos nem compartilhamos seus dados com
            terceiros para fins comerciais.
          </p>
        </section>

        <section>
          <h2>4. Segurança</h2>
          <p>
            Tomamos cuidados básicos para proteger os dados localmente, porém esta é uma versão de teste. Evite inserir
            informações sensíveis ou confidenciais enquanto a aplicação estiver em desenvolvimento.
          </p>
        </section>

        <section>
          <h2>5. Exclusão de dados</h2>
          <p>
            Como este app é simples e experimental, você pode excluir registros diretamente na tela de histórico (se
            disponível) ou reinstalar o app para limpar os dados locais.
          </p>
        </section>

        <section>
          <h2>6. Alterações nesta política</h2>
          <p>
            Esta política pode ser atualizada à medida que o app evolui. Mudanças relevantes serão informadas nas notas de
            versão ou dentro do próprio app quando possível.
          </p>
        </section>

        <section>
          <h2>7. Contato</h2>
          <p>
            Para dúvidas ou sugestões, entre em contato com o desenvolvedor: <a href="mailto:dev@example.com">whebertonfialho@gmail.com</a>
            
          </p>
        </section>

        <footer>
          <p>
            <strong>Aviso:</strong> Este é um aplicativo de controle de ponto simples, criado para fins de estudo e teste.
            Use por sua conta e risco em ambientes de produção.
          </p>
        </footer>
      </div>
    </div>
  );
}

export default App;
